/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx} from "react/jsx-runtime";
import SingleChangelog from "../../../components-protocol-v4/Changelog/SingleChangelog";
export const meta = {
  id: 20,
  image: "default-changelog-v2.png",
  title: "Changelog Notes - V3.3.1-beta",
  shortDescription: "This release we have made some improvements such as making ports optional when creating and updating cluster instance. We have also fixed some important issues.",
  description: "This release we have made some improvements such as making ports optional when creating and updating cluster instance. We have also fixed some important issues.",
  date: "Jan 17th, 2023",
  authorWithPositions: [{
    author: "Mitrasish Mukherjee",
    position: "Cofounder & Product Lead"
  }],
  keywords: ["Health-check", "bug", "fixes", "Instance", "Cloud", "Platform", "Compute", "Live-price", "Upload API", "Avalanche", "WAVAX"]
};
export const content = `
## Compute Improvements

- **Optional Ports:** From now onwards, you can create and update instances without specifying ports.

## Fixes 🛠

- Fixed the issue that caused deployments created with the **Upload API** to fail when the project name contained characters other than letters,
  numbers, or hyphens. These characters will now be **replaced with hyphens** in the Spheron domain
- Fixed the logo for the **Avalanche WAVAX** token
- Fixed the fetching of live prices for **WAVAX** and **WBNB** tokens
- Fixed the issue that caused updates to the Health Check configuration to fail. Also, the Health Check Status was removed from the Cluster
  Instance page when not configured.
- Fixed the issue that prevented new Domains from being added for Cluster instances.
  `;
const MDXLayout = ({children}) => _jsx(SingleChangelog, {
  meta: meta,
  children: content
});
function _createMdxContent(props) {
  return _jsx(_Fragment, {});
}
function MDXContent(props = {}) {
  return _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  }));
}
export default MDXContent;
